import { Floor } from "@pdfking/math"

/** The month `by` months on from month `month` of `year`, January the 1st,
 * and its year. */
export const ShiftMonth = (year: number, month: number, by: number) => {
  const index = year * 12 + month - 1 + by
  return { month: (index % 12) + 1, year: Floor(index / 12) }
}
